import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useUserProfile } from '../hooks/useUserProfile';
import { hasInvoicePipeline } from '../constants/productModule';

/** `/` and unknown paths: invoice orgs → invoices overview; sanctions-only → suppliers. */
export default function OrgHomeRedirect() {
  const { user } = useAuth();
  const { loading, productModule } = useUserProfile(user);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[40vh] text-gray-500 text-sm">
        Loading…
      </div>
    );
  }

  const to = hasInvoicePipeline(productModule) ? '/dashboard' : '/suppliers';
  return <Navigate to={to} replace />;
}
